import React, { useCallback, useEffect } from 'react'

// import { inApp } from './services/bridge'

import { createRoot } from 'react-dom/client'

import { interWbSession } from '@interco/inter-webview-bridge'
import { ENABLE_MSW } from '@/common/constants'

import AppProviders from './contexts'
import Routes from './routes'
import './styles/global.css'
import { inApp } from './services/bridge'
import '@interco/inter-toranja/dist/assets/fonts.css'
import { useToranjaTheme } from './hooks/theme/useToranjaTheme'

const App = () => {
  const { setToranjaTheme } = useToranjaTheme()
  const getAppInfo = useCallback(async () => {
    const response = await interWbSession.getAppInfo()
    interWbSession.editToolbar('', false)

    if (JSON.parse(JSON.stringify(response)).isDarkMode === true) {
      setToranjaTheme('pf-dark')
    }
  }, [setToranjaTheme])
  useEffect(() => {
    if (inApp) getAppInfo()
  }, [getAppInfo])

  return <Routes />
}

const root = createRoot(document.getElementById('root') as HTMLElement)

async function bootstrap() {
  if (ENABLE_MSW) {
    const { worker } = await import('./common/mocks/handlers')
    await worker.start()
  }

  root.render(
    <AppProviders>
      <App />
    </AppProviders>,
  )
}

bootstrap().catch((error) => {
  window.console.error('[bootstrap]', error)
})
